<template>
    <div>
        <div class="text-align-center" v-if="loader === true">
            <loader></loader>
        </div>
        <span v-else>
            <div v-if="erreur == ''">
                <div v-if="conversation.messageDetails != null">
                    <MessageChat :titre="conversation.titreConversation"
                                 :token="token"
                                 :idConversation="conversation.id"
                                 :messages="conversation.messageDetails"
                                 :nomClient="conversation.nomClient"
                                 :initialesClient="conversation.initialeClient"></MessageChat>
                </div>
                <div v-else>
                    Aucun message.
                </div>
            </div>
            <!--Message d'erreur si le cas se présente-->
            <div id="divErreur" v-else>
                {{this.erreur}}
            </div>
        </span>
    </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import MessageChat from '@/components/Contact/MessageChat.vue';
import axios from 'axios';

export default {
  components: {
    Loader,
    MessageChat
  },
  data() {
    return {
        conversation : {},
        token : '',
        loader: true,
        erreur: '',
        body: {
            id : '',
        }
    }
  },
  mounted() {
      if(this.$route.query.token)
      {
        this.token = decodeURIComponent(this.$route.query.token.replace(/\+/g, " ")).replace(/ /g, "+");
      }
      this.body.id = decodeURIComponent(this.$route.query.id.replace(/\+/g, " ")).replace(/ /g, "+");
      this.chargerMessage();
  },
  methods: {
    /**********************************************************
    * Nom : chargerMessage
    * Role : Charge le message
    **********************************************************/
      chargerMessage() {
          const url = process.env.VUE_APP_BASE_API_URL + "messagerie/conversationDetails";

          axios({
              method: "post",
              url: url,
              withCredentials: false,
              data: this.body,
              headers: {
                  token: this.token,
                  Accept: 'application/json',
              }
          })

      .then(response => {
        this.loader = false;

          if (response.status == 200) {
          this.conversation = response.data;
        }
        else {
          this.erreur = "Aucune donnée correspondante n'a été récupérée.";
        }
      })
      .catch(error => {
        this.loader = false;
        this.erreur = "Une erreur est survenue lors de la tentative de récupération des données.";
        console.log(error);
      });
    }
  }
};
</script>

<style scoped src="@/assets/css/Messagerie.css">
</style>